<template>
  <v-row :class="rowClasses.join(' ')">
    <LabelCol v-if="isLabelVisible" :cols="labelCols" :attribute="attribute" />
    <v-col :cols="valueCols" class="pa-0">
      <v-combobox
        v-if="attribute.manual_override"
        :disabled="isCopied || !canEdit"
        :value="value"
        @change="$emit('input', $event)"
        :items="dicts[attribute.name]"
        :item-text="$i18n.locale"
        :loading="loading"
        return-object
        outlined
        :rules="rules"
        v-bind="inputProps"
      />
      <v-select
        v-else
        :disabled="isCopied || !canEdit"
        :value="computedValue"
        @change="$emit('input', $event)"
        :items="dict"
        :item-text="$i18n.locale"
        :loading="loading"
        :multiple="isMultiselect"
        return-object
        outlined
        :rules="rules"
        v-bind="inputProps"
      />
    </v-col>
  </v-row>
</template>

<script>
import LabelCol from './LabelCol';

import { DICTS } from '@/dicts';

export default {
  components: {
    LabelCol
  },
  props: {
    attribute: {
      required: true,
      type: Object
    },
    labelCols: {
      default: 4,
      type: Number
    },
    valueCols: {
      default: 8,
      type: Number
    },
    canEdit: {
      required: true,
      type: Boolean
    },
    isCopied: {
      required: false,
      default: false,
      type: Boolean
    },
    loading: {
      default: false,
      type: Boolean
    },
    value: {
      required: true
    },
    inputProps: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isLabelVisible: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    rowClasses: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data: () => ({
    dict: []
  }),
  computed: {
    dicts: () => DICTS,
    computedValue() {
      if (typeof this.value === 'string') {
        const splittedValue = this.value.split(',');
        this.$emit('input', splittedValue);
        return splittedValue;
      }
      return this.value;
    },
    isMultiselect() {
      return this.attribute.type === 'multiselect';
    },
    rules() {
      const rules = [];
      if (this.attribute.required) {
        rules.push(value => (this.isMultiselect ? value.length > 0 : !!value || this.$i18n.t('default.requiredField')));
      }
      return rules;
    }
  },
  methods: {
    async getDict() {
      if (this.attribute.name !== 'kontakt_cbre') {
        this.dict = this.dicts[this.attribute.name];
      } else {
        await this.$store.dispatch('fetchUsers');
        this.dict = this.$store.getters.getUsers;
      }
    }
  },
  mounted() {
    this.getDict();
  },
  watch: {
    'attribute.value'() {
      this.getDict();
    },
    'attribute.name'() {
      this.getDict();
    }
  }
};
</script>

<style lang="scss">
.v-list-item__title,
.v-select__selection--comma {
  overflow: unset;
  text-overflow: unset;
  white-space: unset;
}
</style>